export default __webpack_public_path__ + "pgnv-assets/0a3d4efab1e641438f4c7b132ac8b5ae.png";